<template>
  <div>
  
  
  
   <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
       
       <div style="margin-top:90px;">
       <h5 style="font-weight:bold;">Associates Access</h5>
  		</div>
		
        <div class="card" style="margin-bottom:50px">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="associates">
                  <el-table-column label="Associate">
            		<template slot-scope="scope">
            			{{scope.row.user.user_info.first_name}} {{scope.row.user.user_info.last_name}}
            		</template>
               </el-table-column>
                 <el-table-column label="Email Address">
            		<template slot-scope="scope">
            			{{scope.row.user.email}}
            		</template>
               </el-table-column>
            		
            		
     			 <el-table-column label="Remove">
            		<template slot-scope="scope">
            			 <p-button v-if="scope.row.has_access==1" type="danger" size="sm" icon @click="removeAccess(scope.row)">
                 			 <i class="nc-icon nc-simple-remove"></i>
                		</p-button>
					</template>
               </el-table-column>
                
                <el-table-column label="Grant">
            		<template slot-scope="scope">
            			 <p-button v-if="scope.row.has_access==0" type="success"  @click="grantAccess(scope.row)">
                 
                 			  <i slot="label" class="nc-icon nc-check-2"></i>Grant Access
                		</p-button>
                		
                		
					</template>
               </el-table-column>
                 
                  
                 
            </el-table>

          </div>
        </div>
        
        
        
  
    </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {

      	this.initPage();
    },
    
     
    data () {
      return {
        coy:[],
        associates:[],
    	eid: this.$route.params.eid,
		account: {
          email: '',
        },
        modelValidations: {
          title: {
          },
          description: {
          },
          email: {
            required: true,
            email:true,
          },
          due_date: {
          	required: true,
          },
         
          
        },
      }
    },
    methods:{
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    getError(fieldName) {
        return this.errors.first(fieldName)
      },
      
      removeAccess(row){
      		const vm = this;
      		swal({
					title: 'Are you sure?',
					text: 'Access to this entity will be removed for this associate.',
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes',
					buttonsStyling: false
				  }).then(function () {
					 const vm2 = vm;
					 let uri = vm.$base_url+'/api/v1/entities/post/remove_associate_access/' +  vm.$route.params.eid;
					
					 ApiService.post(uri, row).then(response => {
	
							swal({
							  title: 'Access Removed',
							  text: 'Access has been removed successfully.',
							  type: 'success',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
							}).then(function () {
								vm2.initPage();
							
							})
							//end swal
						
						
					})


				  })//end swal
      
      },
	  grantAccess(row){
	  
				const vm = this;

				swal({
					title: 'Are you sure?',
					text: 'You are giving the associate access to this entity.',
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes',
					buttonsStyling: false
				  }).then(function () {
					 const vm2 = vm;
					 let uri = vm.$base_url+'/api/v1/entities/post/grant_associate_access/' +  vm.$route.params.eid;
					
					 ApiService.post(uri, row).then(response => {
					
					 
							swal({
							  title: 'Access Granted',
							  text: 'Access to this entity has been granted to the associate',
							  type: 'success',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
							}).then(function () {
								vm2.initPage();
							
							})
							//end swal
						
					})


				  })//end swal
	 
	    },
	    initPage(){
	    	let uri = this.$base_url+'/api/v1/entities/get/entity_associates/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				this.coy = response.data.entity;
				this.associates = response.data.associates;
			})
	    },
	   
	  
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


